/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button as Bt, ButtonProps } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import useStyles from './styles';

const Button: React.FC<ButtonProps> = ({ children, ...rest }) => {
  const classes = useStyles();
  return (
    <Bt
      type="button"
      variant="contained"
      disableElevation
      fullWidth
      className={classes.buttonBox}
      endIcon={<ArrowForwardIcon />}
      color="primary"
      {...rest}
    >
      {children}
    </Bt>
  );
};

export default Button;
